import styled from 'styled-components'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'

export const CreditWrapper = styled.div`
  background: ${colors.gandalf};
  border-radius: 0.625rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.5rem;
  height: 4.816rem;
  margin-bottom: 1.25rem;

  &:last-child {
    margin-bottom: 0;
  }

  h5 {
    font-weight: 900;
    display: flex;
    align-items: center;
    margin: 0;
    margin-bottom: 0.5rem;

    img {
      margin-right: 0.75rem;
      height: 1rem;
    }
  }
`
export const AddedBy = styled.div`
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;

  strong {
    font-weight: 900;
  }
`



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/CreditCards/CreditCards.style.tsx